// extracted by mini-css-extract-plugin
export default {"container":"procedure-view_container__8qwvZ"};